<template>
  <input-widget :model="model" :attribute="attribute" :label="label" :options="options" type="select2"
                :display-field="displayField" :value-field="valueField" :hint="hint" :items="reserveTypes"
                :rules="rules" @select2Select="onSelect"/>
</template>


<script>
  import InputWidget from "./../components/input-widget/InputWidget";
  import {createNamespacedHelpers} from "vuex";

  const {mapState} = createNamespacedHelpers('global');

  /**
   * @author Saiat Kalbiev <kalbievich11@gmail.com>
   */
  export default {
    name: "ReserveTypeSelectInputWidget",
    components: {InputWidget},
    props: {
      model: {
        type: Object,
        required: true
      },
      attribute: {
        type: String,
        required: true
      },
      label: {
        type: [String, Boolean],
        default: null
      },
      hint: {
        type: [Boolean, String],
        default: false
      },
      rules: {
        type: String,
        default: null,
        required: false
      },
      options: {
        type: Object,
        default: () => {
          return {};
        }
      },
      displayField: {
        type: String,
        default: '${item.key}'
      },
      valueField: {
        type: String,
        default: 'value'
      }
    },
    computed: {
      ...mapState(['reserveTypes']),
    },
    methods: {
      onSelect(data) {
        this.$emit('select', data);
      },
    },
  }
</script>

<style scoped>

</style>
